import React from 'react';
import { Stack, Text, Divider, ControlLink } from '@moda/om';
import { hrefFor } from '../../routers';
import './ErrorScreen.scss';

export const ErrorScreen: React.FC = () => (
  <Stack space={7} className="ErrorScreen">
    <Stack space={6} className="ErrorScreen__section">
      <Stack space={2}>
        <Text className="ErrorScreen__title">Oops! Something went wrong on our end.</Text>
        <Text className="ErrorScreen__subtitle">
          Please contact the client service team for assistance.
        </Text>
      </Stack>
      <Stack space={2}>
        <div className="ErrorScreen__info">
          <Text color="cement">
            Domestic:{' '}
            <ControlLink className="ErrorScreen__link" href="tel:+18007079898">
              +1 (800) 707-9898
            </ControlLink>
          </Text>
          <Text color="cement">
            International:{' '}
            <ControlLink className="ErrorScreen__link" href="tel:+12127290984">
              +1 (212) 729-0984
            </ControlLink>
          </Text>
        </div>
        <div className="ErrorScreen__info">
          <Text color="cement">Mon-Fri: 8am-8pm EST</Text>
          <Text color="cement">Sat-Sun: 9am-6pm EST</Text>
        </div>
        <ControlLink className="ErrorScreen__link" href="mailto:support@modaoperandi.com">
          Email Client Services
        </ControlLink>
      </Stack>
    </Stack>
    <Divider />
    <Stack space={6} className="ErrorScreen__section">
      <Text className="ErrorScreen__subtitle">Looking for something? Try the links below.</Text>
      <Stack space={4}>
        <ControlLink
          className="ErrorScreen__link"
          href={hrefFor.ProductCategoryListingPage({ vertical: 'women', section: 'new' })}
        >
          SHOP WOMEN
        </ControlLink>
        <ControlLink
          className="ErrorScreen__link"
          href={hrefFor.TrunkshowIndexPage({ vertical: 'women' })}
        >
          SHOP TRUNKSHOW
        </ControlLink>
        <ControlLink
          className="ErrorScreen__link"
          href={hrefFor.EditorialPage({ slug: 'lauren-santo-domingo' })}
        >
          SHOP LAUREN'S CLOSET
        </ControlLink>
        <ControlLink className="ErrorScreen__link" href="https://help.modaoperandi.com/hc/en-us">
          FAQ
        </ControlLink>
      </Stack>
    </Stack>
  </Stack>
);
